module.exports = __webpack_public_path__ + "static/media/letter-sign.8afc2227.jpg";